export default __webpack_public_path__ + "static/media/library-min.90af8cdf.jpg";